var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "error-container pl-3" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "span",
          {
            staticClass: "color-primary-4 font-16 font-weight-bold flex-grow-1"
          },
          [_vm._v(" (" + _vm._s(_vm.errors.length) + ") Documentos con Error ")]
        ),
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center px-2 rounded-pill border-color--primary-4 cursor-pointer",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _c("em", {
              staticClass: "fa fa-times-circle mr-2 color-primary-4"
            }),
            _c("span", { staticClass: "color-primary-4 font-16" }, [
              _vm._v("Cerrar")
            ])
          ]
        )
      ]),
      _vm.errors.length > 0
        ? _c("div", [
            _c(
              "ul",
              { staticClass: "m-0 pl-4" },
              _vm._l(_vm.errors, function(item, index) {
                return _c(
                  "li",
                  {
                    key: `error-container-${index}`,
                    staticClass: "color-primary-4"
                  },
                  [
                    _c("span", { staticClass: "font-16 font-weight-bold" }, [
                      _vm._v(_vm._s(item.fileName))
                    ]),
                    _vm._v(" - "),
                    _c("span", { staticClass: "font-16" }, [
                      _vm._v(_vm._s(item.description))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex flex-column color-primary-4 align-items-end font-20"
      },
      [
        _c("em", { staticClass: "fa fa-caret-up mb-n1 cursor-pointer" }),
        _c("em", { staticClass: "fa fa-caret-down cursor-pointer" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }